import { Button, cn } from "@tellescope/ui";
import { ChevronUp, ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface HiddenEventsExpanderProps {
  direction: "earlier" | "later";
  onClick: () => void;
  visible: boolean;
  className?: string;
}

export const HiddenEventsExpander = ({ direction, onClick, visible, className }: HiddenEventsExpanderProps) => {
  const { t } = useTranslation("calendar");
  const isEarlier = direction === "earlier";
  const Icon = isEarlier ? ChevronUp : ChevronDown;
  const label = isEarlier ? t("Show earlier events") : t("Show later events");

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={onClick}
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      className={cn(
        "absolute left-1/2 -translate-x-1/2 z-[1001] shadow-md rounded-full px-3 h-7 text-xs gap-1 border",
        "transition-all duration-300 ease-out",
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto delay-500"
          : cn("opacity-0 pointer-events-none delay-0", isEarlier ? "-translate-y-2" : "translate-y-2"),
        className
      )}
    >
      <Icon className="h-3.5 w-3.5" />
      {label}
    </Button>
  );
};
